module.exports = __webpack_public_path__ + "static/img/heyWhale_index_icon01.ae9b403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heyWhale_index_icon01.png
// module id = ArXL
// module chunks = 0